import { useCallback, useState, useEffect } from 'react';

import type { QueryResult } from '@apollo/client';

import type { AuthenticatedRoutesResponse } from 'AuthenticatedRoutesContainer/queries';
import { motd } from 'common/helpers/localStorageHelper';

export type UseMotdInput = QueryResult<AuthenticatedRoutesResponse>;
export type UseMotdOutput = {
  showMotd: boolean;
  acknowledgeMotd: () => void;
};

export function useMotd({ data, loading }: UseMotdInput): UseMotdOutput {
  const [showMotd, setShowMotd] = useState(() => {
    if (motd.acknowledged) {
      return false;
    }

    return !!data?.me.motd;
  });

  useEffect(() => {
    if (motd.acknowledged) {
      return;
    }

    if (!loading) {
      setShowMotd(!!data?.me.motd);
    }
  }, [data, loading, setShowMotd]);

  const acknowledgeMotd = useCallback(() => {
    setShowMotd(false);
    motd.acknowledged = true;
  }, [setShowMotd]);

  return {
    showMotd,
    acknowledgeMotd,
  };
}
